import React, { Component } from 'react'
import { Card, Grid, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { SwxTheme } from 'swx-atomic-component-lib'

const styles = theme => ({
  cardContainer: {
    position: 'relative'
  },
  card: {
    width: '100%',
    marginBottom: 30,
    paddingBottom: 30
  },
  titleArea: {
    paddingRight: 16
  },
  mask: {
    position: 'absolute',
    top: 0,
    bottom: 30,
    left: 0,
    right: 0,
    backgroundColor: SwxTheme.palette.black,
    opacity: 0.5,
    zIndex: 100
  }
})

class SecondaryViewItem extends Component {
  render () {
    const { classes } = this.props
    return (
      <>
        <Grid container direction='row'>
          <Grid item xs={12} sm={4} className={classes.titleArea}>
            <Typography variant='subtitle1' color='primary'>{this.props.name}</Typography>
            <Typography variant='body2'>{this.props.description}</Typography>
          </Grid>
          <Grid item xs={12} sm={8} className={classes.cardContainer}>
            <Card className={classes.card}>
              {this.props.children}
            </Card>
            {this.props.disabled && <div className={classes.mask} />}
          </Grid>
        </Grid>
      </>
    )
  }
}

SecondaryViewItem.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.element.isRequired,
  disabled: PropTypes.bool
}

const SecondaryViewItemComponent = withStyles(styles)(SecondaryViewItem)
export default SecondaryViewItemComponent
